import { create, all } from 'mathjs';
import { expandUnarySymbols } from './unarySymbols';

const math = create(all, {});

export function evaluateExpression(expr: string): number {
  const cleaned = expr
    .replace(/×/g, '*')
    .replace(/÷/g, '/')
    .replace(/π/g, 'pi')
    .replace(/√\(/g, 'sqrt(')
    .replace(/(\d+)²/g, '($1)^2');
  const result = math.evaluate(cleaned);
  if (typeof result === 'number' && Number.isFinite(result)) return result;
  if (result && typeof result === 'object' && 'toNumber' in result) {
    return (result as { toNumber: () => number }).toNumber();
  }
  throw new Error('invalid');
}

export function evaluateScientific(expr: string): number {
  let e = expandUnarySymbols(expr)
    .replace(/×/g, '*')
    .replace(/÷/g, '/')
    .replace(/π/g, 'pi')
    .replace(/√/g, 'sqrt')
    .replace(/sin⁻¹/g, 'asin')
    .replace(/cos⁻¹/g, 'acos')
    .replace(/tan⁻¹/g, 'atan')
    .replace(/sinh/g, 'sinh')
    .replace(/cosh/g, 'cosh')
    .replace(/tanh/g, 'tanh')
    .replace(/sin/g, 'sin')
    .replace(/cos/g, 'cos')
    .replace(/tan/g, 'tan')
    .replace(/ln\(/g, 'log(')
    .replace(/log10\(/g, 'log10(')
    .replace(/random\(\)/g, String(Math.random()))
    .replace(/\^/g, '^')
    .replace(/mod/g, '%');
  const result = math.evaluate(e);
  if (typeof result === 'number' && Number.isFinite(result)) return result;
  if (result && typeof result === 'object' && 're' in result) throw new Error('invalid');
  throw new Error('invalid');
}

export function evaluateEntry(expr: string, scientific = false): number {
  const raw = expr.replace(/\s+/g, '');
  if (!raw) return 0;
  return scientific ? evaluateScientific(raw) : evaluateExpression(raw);
}

export function plotFunction(
  fn: string,
  xMin: number,
  xMax: number,
  samples: number,
): { x: number; y: number }[] {
  const compiled = math.compile(fn.replace(/×/g, '*').replace(/÷/g, '/'));
  const points: { x: number; y: number }[] = [];
  const step = (xMax - xMin) / (samples - 1);
  for (let i = 0; i < samples; i++) {
    const x = xMin + step * i;
    try {
      const y = compiled.evaluate({ x });
      if (typeof y === 'number' && Number.isFinite(y)) points.push({ x, y });
    } catch {
      /* skip */
    }
  }
  return points;
}

export function factorial(n: number): number {
  if (n < 0 || !Number.isInteger(n)) throw new Error('invalid');
  if (n > 170) throw new Error('overflow');
  return math.factorial(n) as number;
}
